// Use Vue and Vuex
import Vue from 'vue'
import Vuex from 'vuex'
import iOsVersion from 'ios-version'

// tell Vue to use Vuex
Vue.use(Vuex)

// get the state object from localStorage
const localState = JSON.parse(window.localStorage.getItem('state')) || {}
const isContinuing = (localState.slidesComplete > 0)
const landscape = (window.innerWidth > window.innerHeight)

const AvailableVideoHeights = [1080, 720, 540, 360]
const VideoSize = String(AvailableVideoHeights.reduce((prev, curr) => (Math.abs(curr - (window.innerHeight * window.devicePixelRatio)) < Math.abs(prev - (window.innerHeight * window.devicePixelRatio)) ? curr : prev)))

const isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
const isExplorer = navigator.userAgent.indexOf('MSIE') > -1
const isFirefox = navigator.userAgent.indexOf('Firefox') > -1
const isCamino = navigator.userAgent.indexOf('Camino') > -1
const isOpera = navigator.userAgent.toLowerCase().indexOf('op') > -1
const isSafari = ((navigator.userAgent.indexOf('Chrome') > -1) && (navigator.userAgent.indexOf('Safari') > -1)) ? false : navigator.userAgent.indexOf('Safari') > -1
const isChrome = ((navigator.userAgent.indexOf('Chrome') > -1) && (navigator.userAgent.toLowerCase().indexOf('op') > -1)) ? false : navigator.userAgent.indexOf('Chrome') > -1
const iosv = iOsVersion(navigator.userAgent)

// build state object
const state = {
  // if not saved to localStorage, slidesComplete defaults to 0, ...
  slidesComplete: 0,
  isCandyCodesComplete: false,
  // ... but gets overridden by localState from localStorage if localState contains slidesComplete
  ...localState,
  isContinuing,
  landscape,
  isExplorer,
  isFirefox,
  isCamino,
  isOpera,
  isSafari,
  isChrome,
  isMobile,
  VideoSize,
  iosv,
}
// mutations mutate the state
const mutations = {
  setSlidesComplete(state, index) {
    state.slidesComplete = index
  },
  setLandscape(state, bool) {
    state.landscape = bool
  },
  setIsContinuing(state, bool) {
    state.isContinuing = bool
  },
  setCandyCodesComplete(state) {
    state.isCandyCodesComplete = true
  },
}

// actions commits mutations
const actions = {
  // for saving the "completed" slides in a gallery in the vuex store
  setSlidesComplete(context, index) {
    const currentSlidesComplete = state.slidesComplete
    if (currentSlidesComplete < index) {
      // if index is higher than whats saved in the state, commit mutation ...
      context.commit('setSlidesComplete', index)
      // ... and save it to localStorage
      context.dispatch('saveState')
    }
  },

  setCandyCodesComplete(context) {
    context.commit('setCandyCodesComplete')
  },

  setIsContinuing(context, bool) {
    context.commit('setIsContinuing', bool)
  },

  // save state to localStorage
  saveState(context) {
    // console.log('saving!', context.state)
    window.localStorage.setItem('state', JSON.stringify(context.state))
  },

  setOrientation(context) {
    if ((window.innerWidth > window.innerHeight) !== context.state.landscape) {
      context.commit('setLandscape', (window.innerWidth > window.innerHeight))
    }
  },
}

export default new Vuex.Store({
  state,
  mutations,
  actions,
})



// WEBPACK FOOTER //
// ./src/store/store.js